import React from 'react'
import ParametrosPerformance from '../../../../components/performance/ParametrosPerformance'

export default function ParametrosPage() {
  return (
    
            <ParametrosPerformance />
          
  )
}
